import React from "react";
import { connect } from "react-redux";
import { cirugiasCarga } from "../mis-tramites/misTramites.act";
import gnpCirugias from "./gnp-cirugias.css";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		listado: state.tramites.cirugias
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargaCirugias: () => {
			dispatch(cirugiasCarga());
		}
	};
};

class GnpCirugias extends React.Component {

	state = {
		ramo : "Línea Azul Plenitud",
		subRamo: ""
	}

	componentWillMount = () => {
		this.props.cargaCirugias();
	}
	
	changeRamo = (ev) => {
		this.setState({ramo: ev.target.value});
	}
	
	changeSubRamo = (ev) => {
		this.setState({subRamo: ev.target.value});
	}

	render() {
		return (
			<div className="gnp-cirugias container">
				<p className="text-center">En esta sección puedes visualizar el listado con la información de las cirugías que GNP cubre en los productos Indemnizatorios. Solo selecciona ramo y trámite.</p>
				<div className="formulario">
					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-right">
							Selecciona un ramo:
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-left">
							<select name="ramo" className="selectPadding browser-default" onChange={this.changeRamo.bind(this)}>
								<option value="Línea Azul Plenitud">Línea Azul Plenitud</option>
							</select>
						</div>
					</div>
					<div className="row mt-20">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-right">
							Selecciona un trámite:
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-left">
							<select name="tramite" className="selectPadding browser-default" onChange={this.changeSubRamo.bind(this)}>
								<option value="">Seleccione una opción</option>
								<option value="Traumatología y Ortopedia">Traumatología y Ortopedia</option>
								<option value="Colecistectomía">Colecistectomía</option>
								<option value="Hernias">Hernias</option>
							</select>
						</div>
					</div>
				</div>
				<div className="row mt-20">
					<div className="col-xs-12 text-center">
						<p></p>
					</div>
					<div className="col-xs-12 text-center">
						<ul className="listado">
							<li>
								<p>Resultado de la búsqueda</p>
								<div className="layout-row layout-align-space-between-center cabecera">
									<div className="flex-10">CPT</div>
									<div className="">Nombre de la Cirugía</div>
									<div className="">% de <br />indemnización</div>
								</div>
							</li>
							{ this.props.listado.map((item, i) => {
								if(this.state.subRamo == "" || this.state.subRamo == item.tramite) {
									return (
										<li key={i} className="layout-row layout-align-space-between-start layout-padding">
											<div>{item.cpt}</div>
											<div>{item.descripcion}</div>
											<div>{item.porcentaje}</div>
										</li>
									);
								}
							})}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(GnpCirugias);


// WEBPACK FOOTER //
// ./src/gnp-servicios-cirugias/gnp-cirugias.cmpt.js